import { Proficiency } from './proficiency';
import { Topic } from './topic';

export class SubTopic {
    id=0
    name:string=""
    description:string=""
    datecreated:Date
    lastupdated:Date
    taskTemplates:[]
    server_topic_id=0
    topicName=""
    topicId=0
    is_open=0
    topic:Topic = new Topic()
    server_subtopic_id:number=0
    subtopiccode:string=""
    proficiencies:Proficiency[]=[]

}
